<app-deal-owner
  [deal]="deal"
  [canManageDeals]="canManageDeals"
  [loading]="loading"
  [readOnly]="readOnly"
  [advancedDeal]="advancedDeal"
  (updateOwner)="updateOwner($event)"
  (loadOwner)="loadOwner()">
</app-deal-owner>
